module.exports = __webpack_public_path__ + "76580779717a57246a639e275ec62853.svg";